// Copyright © 2021 Move Closer

import { MappingConfig, MappingTypes } from '@movecloser/front-core'

/**
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 */
export const authorAdapterMap: MappingConfig = {
  id: 'id',
  avatar: 'avatar',
  name: {
    type: MappingTypes.Function,
    value: item => {
      return item.nickname
    }
  }
}
